import "./ProcessedDocuments.scss";

import CarrierSearch from "./CarrierSearch";
import { useEffect, useState } from "react";
import Api from "../../api";
import useAccessToken from "../../utils/useAccessToken";
import Header from "../Header";
import useLoader from "../../utils/useLoader";
import LoadingOverlayWrapper from "react-loading-overlay-ts";
import Content from "./Content";

function ProcessedDocuments() {
  const [selectedCarrier, setSelectedCarrier] = useState("Select a Carrier");
  const [carriers, setCarriers] = useState([]);
  const { decodedAccessToken, userData, organizationData } = useAccessToken();
  const { isPageLoading, setIsPageLoading } = useLoader();

 const getSites = async () => {
    setIsPageLoading(true);
    if (Object.keys(decodedAccessToken).length === 0) return;
    if (!userData.orgID) return;

    const response = await Api.DataService.Sites.getAllSites();

    if (!response.success) {
      setIsPageLoading(false);
      return;
    }

    setCarriers(response.data);
    setIsPageLoading(false);
  };

  useEffect(() => {
    getSites();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [decodedAccessToken, organizationData]);

  return (
    <LoadingOverlayWrapper active={isPageLoading} spinner>
    <div className="container">
      <Header />
      <div className="commission-container">
        <div className="commission-carrier-search">
          <CarrierSearch
            selectedCarrier={selectedCarrier}
            setSelectedCarrier={setSelectedCarrier}
            carriers={carriers}
          />
        </div>
        <div className="commission-carrier-content">
          <Content
            selectedCarrier={selectedCarrier}
          />
        </div>
      </div>
    </div>
    </LoadingOverlayWrapper>
  );
}

export default ProcessedDocuments;
